import { c as _c } from "react/compiler-runtime";
interface RehabilitationMedicineIconProps {
  size?: number;
  className?: string;
}
const RehabilitationMedicineIcon = t0 => {
  const $ = _c(16);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M5 9.23083L8.38192 10.839C8.55541 10.9212 8.62729 11.1298 8.54137 11.3016C8.47486 11.4355 8.39225 11.604 8.30302 11.7924" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M15.9004 22.3193L16 22.5L17.3677 22.8575C17.5195 22.8781 17.6526 22.9673 17.7479 23.0972C17.8433 23.2276 17.9004 23.4 17.9004 23.5865C17.9004 23.9909 17.6323 24.3193 17.3015 24.3193H15.9004" stroke="currentColor" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M5 3.99994L11.8221 7.68878C12.2732 7.9325 12.5549 8.40466 12.5549 8.91812V11.7924" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t9 = <path d="M8 14L12 14" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t10 = <path d="M16.7148 5.85256V12.1257C16.7148 12.6825 16.9499 13.2137 17.3626 13.5884L18.3936 14.5236C18.4853 14.6066 18.5374 14.7248 18.5374 14.8487V21" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t11 = <path d="M23.1167 6V11.8975C23.1167 12.421 22.8584 12.9204 22.4061 13.2727L21.2749 14.1518C21.1743 14.2299 21.1167 14.341 21.1167 14.4575V21" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t12 = <path d="M16.7148 10.4678H22.7148" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t13 = <path d="M18.7148 16H20.7148" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t14 = <path d="M15.6543 4.68144V5.39599C15.6543 5.50442 15.733 5.59847 15.8427 5.61946C18.4915 6.12685 21.2171 6.12685 23.8659 5.61946C23.9756 5.59847 24.0543 5.50442 24.0543 5.39599V4.68144C24.0543 4.26223 23.6673 3.94068 23.2409 4.00925C20.9985 4.36984 18.7101 4.36984 16.4676 4.00925C16.0413 3.94068 15.6543 4.26223 15.6543 4.68144Z" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t15 = <path d="M11.2722 24.5306H10.1589C9.80411 24.5306 9.45427 24.4379 9.14722 24.2623C8.83964 24.0869 8.58167 23.8331 8.40128 23.5285C8.00232 22.8553 8.01984 22.0295 8.44692 21.3734L8.70175 20.9822C8.89702 20.6826 8.94423 20.3024 8.82803 19.9651C8.23691 18.2443 7.25873 15.1588 7.348 13.8249C7.3689 13.5112 7.90186 12.2008 8.03842 11.8693C8.05751 11.823 8.10262 11.7929 8.15277 11.7929H12.6424C12.7107 11.7929 12.7661 11.8483 12.7661 11.9167V14.16" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    t16 = <path d="M12.7656 13.5098V20.4409C12.7656 20.5865 12.8466 20.7176 12.9771 20.7831L15.653 22.1229C15.6949 22.1439 15.7214 22.1868 15.7214 22.2336V24.4069C15.7214 24.4752 15.6659 24.5306 15.5976 24.5306H11.2339" stroke="currentColor" strokeWidth="1.3" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t10;
    $[3] = t11;
    $[4] = t12;
    $[5] = t13;
    $[6] = t14;
    $[7] = t15;
    $[8] = t16;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
  } else {
    t10 = $[2];
    t11 = $[3];
    t12 = $[4];
    t13 = $[5];
    t14 = $[6];
    t15 = $[7];
    t16 = $[8];
    t6 = $[9];
    t7 = $[10];
    t8 = $[11];
    t9 = $[12];
  }
  let t17;
  if ($[13] !== t3 || $[14] !== t5) {
    t17 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}{t8}{t9}{t10}{t11}{t12}{t13}{t14}{t15}{t16}</svg>;
    $[13] = t3;
    $[14] = t5;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  return t17;
};
export default RehabilitationMedicineIcon;